export type AptitudeState = {
  filtre: string;
};

export const initialState: AptitudeState = {
  filtre: '',
};
